import type { TextParsedTrack } from '../model/track.ts';
import { parseClockTime } from './clock.ts';

/** Mirrors legacy parseVttBasedTrack (SRT-style numbered cues only). Produces Cue.text via html. */
export function parseWebVtt(str: string): TextParsedTrack {
  const tracks: TextParsedTrack['tracks'] = [];
  const sections: string[][] = [];
  const lines = str.split(/[\n\r]/);
  const beginIndex = lines.indexOf('1');

  if (beginIndex === -1) {
    return { type: 'text', tracks: [] };
  }

  let next = 2;
  let arr: string[] = [];

  for (let i = beginIndex + 1, len = lines.length; i < len; i += 1) {
    const line = lines[i];
    if (line === undefined || line.trim() === '') continue;
    if (line === String(next)) {
      sections.push(arr);
      next += 1;
      arr = [];
    } else {
      arr.push(line.trim());
    }
  }

  if (arr.length > 0) {
    sections.push(arr);
  }

  for (let i = 0; i < sections.length; i += 1) {
    const sectionLines = sections[i] ?? [];
    let begin: number | null = null;
    let end: number | null = null;
    let html = '';

    for (let j = 0; j < sectionLines.length; j += 1) {
      const line = sectionLines[j] ?? '';
      if (j === 0) {
        const regex = /^(\d+:\d+:\d+[.,]\d+)\s-->\s(\d+:\d+:\d+[.,]\d+)/;
        const exec = regex.exec(line);
        if (exec !== null) {
          begin = parseClockTime(exec[1] ?? null);
          end = parseClockTime(exec[2] ?? null);
        }
        continue;
      }

      html += line.replaceAll(/<[^>]*>/g, '');
      if (j !== sectionLines.length - 1) {
        html += '<br>';
      }
    }

    tracks.push({ begin, end, html });
  }

  return { type: 'text', tracks };
}
